import axios from "axios";
import { baseUrl } from "../util";

/**
 * Get LCA Results data for a product
 * Returns environmental impact results per lifecycle module based on selected phases
 * @param {Object} params
 * @param {string} params.productId - Product ID
 * @param {Function} params.setObjects - Callback to set the LCA results data
 */
export const getLCAResults48Data = ({ productId, setObjects = () => {} }) => {
  const config = {
    method: "get",
    url: `${baseUrl}/api/business/product/${productId}/lca-results-48-data`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (response?.data?.data) {
        setObjects(response.data.data);
      } else {
        setObjects(null);
      }
    })
    .catch(function (error) {
      console.error("Error fetching LCA results data:", error);
      setObjects(null);
    });
};

